import { createContext } from 'react'

export type Lang = 'no' | 'en'

/** BCP 47 locale used when formatting dates and numbers in each UI language. */
export const LANG_LOCALE: Readonly<Record<Lang, string>> = { no: 'nb-NO', en: 'en-GB' }

export interface I18nContextValue {
  lang: Lang
  setLang: (lang: Lang) => void
  t: (key: string, vars?: Record<string, string | number>) => string
}

export const I18nContext = createContext<I18nContextValue | null>(null)
